import React from "react";
import "./About.scss";
import insta from "../Images/instagram (1).png";
import twitter from "../Images/twitter (1).png";
import linkedin from "../Images/linkedin (2).png";
import github from "../Images/github.png";
const About = () => {
  return (
    <div className="aboutSec">
      <div className="aboutDev">
        <h1>About Developers</h1>
      </div>
      <div className="cards">
        <div className="cardOne">
          <div className="circle">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/dscghrcecertificates.appspot.com/o/Untitled-1-02.png?alt=media&token=53f929b2-5738-48ae-b048-0ced0e13b25f"
              alt=""
            />
          </div>
          <div className="infoAbout">
            <p className="name">Roshan Paturkar</p>
            <p>Android Developer</p>
            <p>Accenture</p>
          </div>
          <br />
          <br />
          <br />
          <div className="scons">
            <a href="https://www.instagram.com/roshan_paturkar/">
              <i class="fa fa-instagram"></i>
            </a>
            <a href="https://twitter.com/roshan_paturkar">
              <i class="fa fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/in/roshan-paturkar/">
              <i class="fa fa-linkedin"></i>
            </a>
            <a href="https://github.com/roshanpaturkar">
              <i class="fa fa-github"></i>
            </a>
          </div>
        </div>
        <div className="cardTwo">
          <div className="circle">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/dscghrcecertificates.appspot.com/o/Untitled-1-09.png?alt=media&token=4fe427d3-fd9e-434b-b08d-16a00c693c47"
              alt=""
            />
          </div>
          <div className="infoAbout">
            <p className="name">Aniket Singh</p>
            <p>Flutter Developer</p>
            <p>DSC GHRCE</p>
          </div>
          <br />
          <br />
          <br />
          <div className="scons">
            <a href="https://www.instagram.com/aniket.siingh/">
              <i class="fa fa-instagram"></i>
            </a>
            <a href="https://twitter.com/aniketsiingh">
              <i class="fa fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/in/aniket-singh-69665419a/">
              <i class="fa fa-linkedin"></i>
            </a>
            <a href="https://github.com/Anikets08">
              <i class="fa fa-github"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
